/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
export * as operations from './operations';
export * from './data-contracts';
/** Version of the API specification */
export const specVersionHash = "7892aae7d2871af44967c500f64c72b7d32cfa104294737885c46a85d73366fa";